import {
	DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
} from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo, RovoLogoFromGlyph } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { HubSpotFilterIcon } from './icon';
import { HubSpotIcon } from './search-result-icon';

export const hubSpotConfig: ThirdPartyConfig = {
	displayName: 'HubSpot',
	id: 'hubspot',
	resourceType: 'hubspot-connector',
	icon: get3PLogo(HubSpotFilterIcon, 'HubSpot', 'medium'),
	searchResultIcon: RovoLogoFromGlyph(HubSpotIcon, 'HubSpot'),
	integrationAri: 'ari:cloud:platform::integration/hubspot',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.CustomerOrg,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Deal,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Deal],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch', 'lastUpdatedBy', 'createdBy'],
	requiresOauth: true,
	isEnabled: () => true,
};
